var _rect, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWe2Blue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 117,
    viewBox: "0 0 156 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_73",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 156,
    height: 117
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 117,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_73)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 94,
    r: 71,
    fill: "#F5F5B9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 50.78L58.76 74.38H57.93L55.86 60.88H48.91L46.84 74.38H46.01L44.77 50.78H35L38.64 92.18H48.99L52.22 78.76H52.55L55.7 92.18H66.05L70.02 50.78H60Z",
    fill: "#28BEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.59 67.67V63.45C81.59 60.22 83.99 57.74 87.22 57.74C90.61 57.74 92.85 60.22 92.85 63.45V67.67H81.59ZM81.59 75.78H102.78V63.44C102.78 55 96.74 49.28 87.22 49.28C77.7 49.28 71.66 54.99 71.66 63.44V79.5C71.66 87.94 77.87 93.66 87.22 93.66C96.57 93.66 102.78 87.95 102.78 79.5H92.85C92.85 82.73 90.61 85.21 87.22 85.21C83.83 85.21 81.59 82.73 81.59 79.5V75.77V75.78Z",
    fill: "#28BEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.43 54.82C137.43 46.62 130.14 40 121.29 40C112.44 40 105.15 46.62 105.15 54.82V59.12H115.08V54.65C115.08 51.17 117.48 48.44 121.29 48.44C125.1 48.44 127.5 51.17 127.5 54.65V56.6C127.5 59.08 126.34 60.99 124.69 61.98L114.92 67.69C110.12 70.34 105.98 73.49 105.98 81.93V92.17H136.12V83.73H115.92V81.94C115.92 79.46 117.08 77.55 118.73 76.56L128.5 70.85C133.3 68.2 137.44 65.88 137.44 56.61V54.83L137.43 54.82Z",
    fill: "#28BEBE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWe2Blue);
export default __webpack_public_path__ + "static/media/we2Blue.53572e07d96b29e1160d325946f75d82.svg";
export { ForwardRef as ReactComponent };